module.exports = __webpack_public_path__ + "static/media/img-feature-salary-200@3x.9d7d49b6.png";